export default "__VITE_ASSET__CY7rzn4x__"